/**
 * Entry — side-effect order orchestration (SPEC.md §4.1 REQ-BOOT-1).
 *
 * Script-parse-time order (all observable before DOM-ready):
 *  (a) state init incl. localStorage read + window.cpc  — state/app-state
 *  (b) compat event patches IIFE                        — compat/event-patches
 *  (c) page-processing module side effects (jquery-ui dialog registration on
 *      the bundled jQuery, window fn exposure, window.cpc.renderCalculator)
 *      — pulled in via bootstrap/detect-page's import graph
 *  (d) cpcRestoreFormData() — the FormData iframe-restore IIFE equivalent
 *  (e) DOM-ready registration ($(document).ready on the BUNDLED jQuery)
 *
 * CSS side-effect imports compose dist plugins.css: the base stylesheet first
 * (DIV-035), slider.css + jquery-ui dialog.css through (c)'s import graph, then
 * the jquery-ui core/widget/theme files below (research/01 §7.1; DIV-036
 * dropped base.css's every-widget imports and moved pintura.css next to
 * pintura-editor.js).
 */
// DIV-035: the calculator's base stylesheet leads plugins.css (it used to be the
// first thing store/style/app served), so every later section still overrides it.
import "./styles/store-base.css";
import { appState } from "./state/app-state";
import "./compat/event-patches";
import $ from "jquery";
import { installReplaceAllPolyfill } from "./compat/polyfills";
import { installJqueryFallback } from "./compat/jquery-fallback";
import { cpcRestoreFormData } from "./bootstrap/restore-form-data";
import { getPriceFailure } from "./pricing/price-failure";
import { DetectPage } from "./bootstrap/detect-page";
// Startup telemetry. Module evaluation registers nothing and reads nothing —
// the single per-page tracker is created lazily on the first bootstrap call
// (reads window.cpcClientPerformanceMarker then). No timer, await or request.
import "./performance/client-performance-lifecycle";
// DIV-036: only the jQuery UI widgets the bundle uses (slider; dialog with its
// button, draggable and resizable parts) — base.css pulled in every widget's
// stylesheet (datepicker, tabs, menu, …), and Pintura's stylesheet now ships
// next to pintura-editor.js, loaded with it.
import "jquery-ui/themes/base/core.css";
import "jquery-ui/themes/base/slider.css";
import "jquery-ui/themes/base/button.css";
import "jquery-ui/themes/base/draggable.css";
import "jquery-ui/themes/base/resizable.css";
import "jquery-ui/themes/base/theme.css";

installJqueryFallback(); // DIV-001 — outward bridge for themes without jQuery
// DIV-004: every internal call site uses the BUNDLED $ (theme jQuery is never
// consumed). Exposed on window.cpc for the e2e harness and live-store
// debugging; themes must not depend on its version. Non-enumerable so the
// key doesn't appear on the enumerated window.cpc surface.
window.cpc = window.cpc || {};
Object.defineProperty(window.cpc, "$", { value: $, enumerable: false, configurable: true });
// Lets the BUILDER ask, at the moment it matters, whether the last price it
// worked out was usable — rather than relying on having caught the event when
// it fired. A listener can miss the first evaluation (mount order, a reload, a
// preview that renders late), and a missed event silently means "all fine",
// which would let a calculator that shows no price be saved. Asking is the
// authoritative answer; the event stays for live updates while typing.
// Non-enumerable, same as `$` above: nothing about the shopper-facing surface
// changes, and on a real storefront nothing ever calls this.
Object.defineProperty(window.cpc, "getPriceFailure", {
  value: getPriceFailure,
  enumerable: false,
  configurable: true,
});
cpcRestoreFormData();

$(document).ready(function () {
  installReplaceAllPolyfill();
  if (appState.cpc_pageLoaded === false) {
    appState.cpc_pageLoaded = true;
    console.log("calculator loading");
    if (typeof window.Shopify !== "undefined") {
      appState.cpc_shopUrl = window.Shopify.shop;
      if (window.meta.product !== undefined) {
        appState.cpc_productId = window.meta.product.id;
      }
    } else {
      console.log("calculator loading in preview mode");
      var getUrl = $("#calculator_preview_storeurl").val();
      appState.cpc_shopUrl = getUrl as any;
      appState.cpc_isPreview = true;
    }

    //Only load calculator if its not loaded already
    var idUpdated = document.querySelector('select[name="oldId"]');
    if (idUpdated == null) DetectPage();
  }
});
